module.exports = __webpack_public_path__ + "static/media/step3b.ac100327.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Tour/assets/step3b.png
// module id = 3733
// module chunks = 0